<template>
  <div
    class="topic-card-section overflow-hidden rounded-5 border_border_grey d-flex justify-content-between align-items-center nowrap"
    :id="term_topic_id"
    draggable="true"
    @dragover.prevent
    @dragstart="moveTopicCard($event, term_topic_id)"
    @drop="dropTopicCard($event, term_topic_id)"
    @dragend="dragFinish"
  >
    <div
      class="left d-flex justify-content-start align-items-center nowrap"
      :id="term_topic_id"
    >
      <div
        class="drag-holder color_white_bg position-relative p-4 mr-3"
        @dragover.prevent
        :id="term_topic_id"
      >
        <img
          v-lazy="localImg('drag-vertical.svg')"
          class="select-none"
          alt="drag-icon"
          :id="term_topic_id"
          @dragstart.prevent
        />
      </div>

      <div class="topic-title color_ash" :id="term_topic_id">
        {{ topic_title }}
      </div>
    </div>
    <div
      class="right d-flex justify-content-end align-items-center nowrap"
      :id="term_topic_id"
      @dragover.prevent
    >
      <!-- EDIT TOPIC -->
      <div
        class="avatar color_white_bg pointer mr-3"
        :id="term_topic_id"
        title="Edit"
        v-if="false"
      >
        <span
          class="icon-edit-pen border_grey_dark font-15 flex-center"
          :id="term_topic_id"
        ></span>
      </div>

      <!-- REMOVE TOPIC -->
      <div
        class="avatar color_white_bg pointer mr-2"
        :id="term_topic_id"
        @click="removeTopicFromList"
        title="Remove"
      >
        <span
          class="icon-minus brand_tonic font-15 flex-center"
          :id="term_topic_id"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopicCardRow",

  props: {
    topic_id: Number,
    topic_data_id: Number,
    topic_title: String,
    term_topic_id: String,
    is_custom: Number,
    learning_area: Array,
  },

  methods: {
    moveTopicCard(e, term_id) {
      e.target.classList.add("dragging");
      e.dataTransfer.dropEffect = "move";
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("Topic", term_id);
    },

    dropTopicCard(e, term_id) {
      e.dataTransfer.setData("Drop Index", term_id);
    },

    dragFinish($event) {
      $event.target.classList.remove("dragging");
      $event.dataTransfer.clearData();
    },

    removeTopicFromList() {
      let term = this.term_topic_id.split("_")[0];
      this.$bus.$emit("event-bus-remove-topic", {
        id: this.topic_id,
        topic_data_id: this.topic_data_id,
        term,
        is_custom: this.is_custom,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topic-card-section {
  margin-bottom: 3px;
  cursor: move;

  img {
    @include transform_center;
    user-drag: none; //SAFARI
    pointer-events: none;
    // @include equal_min_edge();
  }

  .topic-title {
    font-size: 13.5px;
    line-height: 19px;

    @include breakpoint_max(lg) {
      font-size: 13px;
    }
    @include breakpoint_max(xs) {
      font-size: 12px;
    }
  }

  .avatar {
    transition: all 0.4s ease-in-out;

    &:hover {
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
    }
  }
}

.dragging {
  background: $brand_red_light !important;
  opacity: 1;
}
</style>
